import { render, staticRenderFns } from "./ApprovalSubmitterStateItem.vue?vue&type=template&id=774a14b1&"
import script from "./ApprovalSubmitterStateItem.vue?vue&type=script&lang=js&"
export * from "./ApprovalSubmitterStateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports